import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '🤖',
      title: 'AI-Powered Nutrition Tracking',
      description: 'Simply take a photo of your meal and our AI identifies ingredients and calculates accurate calorie counts.',
    },
    {
      icon: '🏃‍♂️',
      title: 'Exercise Tracking',
      description: 'Automatically track your workouts and calories burned using AI analysis or just syncing SlimBuddy with Apple Health.',
    },
    {
      icon: '🎯',
      title: 'Goal Setting & Tracking',
      description: 'Set realistic targets and monitor your progress with detailed analytics.',
    },
    {
      icon: '⚖️',
      title: 'Simple yet informative',
      description: 'SlimBuddy is designed with simplicity in mind. All features you need and nothing to distract you from your goals',
    }
    // {
    //   icon: '💡',
    //   title: 'Intelligent Meal Planning',
    //   description: 'Get personalized meal suggestions that fit your calorie budget and dietary preferences.',
    // },
    // {
    //   icon: '🏆',
    //   title: 'Motivation & Rewards',
    //   description: 'Stay motivated with achievement badges, streaks, and personalized encouragement from your AI buddy.',
    // },
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="features-header">
          <h2>Why Choose SlimBuddy?</h2>
          <p>Powerful features and simple design to make your weight loss journey effortless and effective</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;